import { useMemo, useState } from 'react'
import {
  saveMotivoAtraso,
  updateMotivoAtraso,
} from '../../../../../services/api/https/registration/motivo-atraso.http'
import { getUsuarioInfo } from '../../../../../services/localstorage/localstorage.service'
import { errorHandler } from '../../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  SAVE_MOTIVO: 'Salvando novo motivo',
  EDIT_MOTIVO: 'Editando motivo',
  SAVE_MOTIVO_SUCCESS: 'Motivo salvo com sucesso',
}

const INITIAL_STATE = {
  motivoAtraso: {
    id: 0,
    name: '',
    type: 'Veículo T1',
  },
  tps: [],
  updatedMotivo: {},
  selecionarTodos: false,
  globalFilter: '',
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export const TYPES = [
  { label: 'Veículo T1', value: 'Veículo T1' },
  { label: 'Veículo T2', value: 'Veículo T2' },
  { label: 'Entrega', value: 'Entrega' },
]

export default function useModalMotivoAtraso() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers
    const throwError = err => {
      setState(prevState => ({
        ...prevState,
        errorMessage: errorHandler(err),
        loadingMessage: LOAD_MESSAGE.NONE,
      }))
    }

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      updateMotivoAtraso(motivoAtraso, tps) {
        updateMotivoAtraso({ ...motivoAtraso, tps: tps.map(tp => tp.id) }, getUsuarioInfo().id)
          .then(motivo =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.SAVE_MOTIVO_SUCCESS,
              updatedMotivo: motivo,
            })),
          )
          .catch(err => throwError(err))
      },

      saveMotivoAtraso(motivoAtraso, tps) {
        saveMotivoAtraso({ ...motivoAtraso, tps: tps.map(tp => tp.id) }, getUsuarioInfo().id)
          .then(motivo =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.SAVE_MOTIVO_SUCCESS,
              updatedMotivo: motivo,
            })),
          )
          .catch(err => throwError(err))
      },

      //Events
      onBtnSalvarClicked(motivoAtraso, tps) {
        const tpsSelecteds = tps.filter(tp => tp.selected)
        if (!tpsSelecteds.length) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione pelo menos 1 TP para associar',
          }))
        } else if (motivoAtraso.id)
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.EDIT_MOTIVO }))
        else setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE_MOTIVO }))
      },

      onFieldChange(field, value) {
        setState(prevState => {
          prevState.motivoAtraso[field] = value
          return { ...prevState }
        })
      },

      onInit(motivoAtraso, tps) {
        setState(prevState => {
          prevState.motivoAtraso = { ...INITIAL_STATE.motivoAtraso }
          if (motivoAtraso) {
            const mergedTps = tps.map(tp => {
              const selectedTp = motivoAtraso.tps.find(t => t.id === tp.id)
              tp.selected = !!selectedTp
              return tp
            })
            prevState.motivoAtraso = { ...motivoAtraso }
            prevState.selecionarTodos = false
            prevState.tps = mergedTps
          } else {
            prevState.selecionarTodos = false
            prevState.tps = tps
          }
          return { ...prevState }
        })
      },

      onChangeSelecionarTodos(value) {
        setState(prevState => {
          prevState.selecionarTodos = value
          prevState.tps = prevState.tps.map(tp => ({ ...tp, selected: value }))
          return { ...prevState }
        })
      },

      onChangeGlobalFilter(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },

      onCheckboxChange(tp) {
        setState(prevState => {
          const index = prevState.tps.findIndex(t => t.id === tp.id)
          if (index !== -1) {
            prevState.tps[index].selected = !tp.selected
          }
          return { ...prevState }
        })
      },
    }
  }, [])

  return { state, localDispatch }
}
